import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    CloudDownloadOutlined,
    ControlOutlined,
    DatabaseOutlined,
    DesktopOutlined,
    GlobalOutlined,
    PictureOutlined,
    ProfileOutlined,
    QrcodeOutlined,
    ShopOutlined,
    TeamOutlined,
    UserOutlined,
} from '@ant-design/icons';
import routes from '@routes';

import apiConfig from './apiConfig';

// Digibes is the company brand. Product navigation stays at one level:
// Kitplay, ReadyBoard and Website Order.
export const navMenuConfig = [
    {
        type: 'group',
        label: <FormattedMessage id="navigation.administration" defaultMessage="Administration" />,
        key: 'administration',
        children: [
            {
                label: <FormattedMessage id="navigation.administrators" defaultMessage="Administrators" />,
                key: 'administrators',
                path: routes.adminsListPage.path,
                icon: <TeamOutlined />,
                permissions: [apiConfig.account.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.customers" defaultMessage="Customers" />,
                key: 'customers',
                path: routes.customerListPage.path,
                icon: <UserOutlined />,
                permissions: [apiConfig.customer.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.shopAccounts" defaultMessage="Shop accounts" />,
                key: 'shop-accounts',
                path: routes.shopAccountListPage.path,
                icon: <ShopOutlined />,
                permissions: [apiConfig.shopAccount.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.digibesRequest" defaultMessage="Devices request" />,
                key: 'digibes-request',
                path: routes.deviceRequestListPage.path,
                icon: <ProfileOutlined />,
                permissions: [apiConfig.kitplayRequest.getList.baseURL],
            },
        ],
    },
    {
        type: 'group',
        label: <FormattedMessage id="navigation.products" defaultMessage="Products" />,
        key: 'products',
        children: [
            {
                label: <FormattedMessage id="navigation.kitplay" defaultMessage="Kitplay" />,
                key: 'kitplay',
                path: routes.listKitPlayDevicePage.path,
                icon: <DesktopOutlined />,
                permissions: [apiConfig.kitplayDevice.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.pickupDisplay" defaultMessage="ReadyBoard" />,
                key: 'pickup-display',
                path: routes.listOrderDevicePage.path,
                icon: <ShopOutlined />,
                permissions: [apiConfig.kitplayDevice.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.ordercon" defaultMessage="Ordercon" />,
                key: 'ordercon',
                path: routes.listOrderconDevicePage.path,
                icon: <ControlOutlined />,
                permissions: [apiConfig.device.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.qrLive" defaultMessage="QR Live" />,
                key: 'qr-live',
                path: routes.listQrliveDevicePage.path,
                icon: <QrcodeOutlined />,
                permissions: [apiConfig.device.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.websiteOrder" defaultMessage="Website Order" />,
                key: 'website-order',
                path: routes.restaurantListPage.path,
                icon: <GlobalOutlined />,
                permissions: [apiConfig.restaurant.getList.baseURL],
            },
        ],
    },
    {
        type: 'group',
        label: <FormattedMessage id="navigation.system" defaultMessage="System" />,
        key: 'system',
        children: [
            {
                label: <FormattedMessage id="navigation.contentLibrary" defaultMessage="Content library" />,
                key: 'content-library',
                path: routes.mediaListPage.path,
                icon: <PictureOutlined />,
                permissions: [apiConfig.templateImage.getList.baseURL],
            },
            {
                label: <FormattedMessage id="navigation.appManagement" defaultMessage="App Management" />,
                key: 'app-management',
                path: routes.appManagementPage.path,
                icon: <CloudDownloadOutlined />,
                permissions: [apiConfig.file.uploadVersion.path],
            },
            {
                label: <FormattedMessage id="navigation.serverProvider" defaultMessage="Server Provider" />,
                key: 'server-provider',
                path: routes.serverProviderListPage.path,
                icon: <DatabaseOutlined />,
                permissions: [apiConfig.serverProvider.getList.baseURL],
            },
        ],
    },
];
